export default __webpack_public_path__ + "static/media/AreaFamily.d2febd3d.svg";